import { ReactElement } from "react";
import { BusyIndicator } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";
import { LiveTileContent } from "../../LiveTileContent";
import { AuthenticationRequired } from "../AuthenticationRequired";
import { PlanningItemModel, PlanningLiveInformationState } from "./PlanningLiveTileContent";

export type PlanningScheduleContentProps = {
	state: PlanningLiveInformationState;
	appName: string;
	onReload: () => void;
	renderItems: (items: readonly PlanningItemModel[]) => ReactElement;
};

export const PlanningScheduleContent = (props: PlanningScheduleContentProps): ReactElement => {
	const {
		state,
		appName,
		onReload,
		renderItems
	} = props;

	switch (state.status) {
		case "isLoading":
			return (<BusyIndicator />);
		case "globalFailure":
			return (
				<LiveTileContent.NoResults
					icon="gear"
					title={localize("_UnableToRetrieveItems")}
					message={localize("_WeWereUnableToRetrieveTheItems")}
					onRetry={onReload}
					trackingId="global-failure"
				/>
			);
		case "authenticationRequired":
			return (
				<AuthenticationRequired
					appName={appName}
					authenticationModel={state.authenticationModel}
					onAuthenticated={onReload}
				/>
			);
		case "loaded":
			if (state.items.length === 0) {
				return (
					<LiveTileContent.NoResults
						icon="calendar"
						title={localize("_NoItemsToShow")}
						message={localize("_ThereAreCurrentlyNoItemsToShowHere")}
						trackingId="no-items"
					/>
				);
			}

			return renderItems(state.items);
		default:
			return never(state);
	}
};
PlanningScheduleContent.displayName = "PlanningScheduleContent";
